import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  click = (event) => {
    event.target.outerHTML = event.target.dataset.replaceWith;
  };
}
